import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, EventEmitter, Inject, model, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { GenericEdit } from 'src/app/interfaces/generic-edit';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';




@Component({
    selector: 'titkok-attribute',
    templateUrl: './tiktok-attribute.component.html',
    styleUrl: './tiktok-attribute.component.scss',
    standalone: false
})
export class TiktokAttributeComponent  implements OnInit {

  @Output() saving:EventEmitter<{changing:boolean, keepOpen:boolean}> = new EventEmitter();
  attribValidator:AbstractControl[] = [];
  attribs:object[] = [];
  buttonList:ButtonList[] = [];
  product:Object;
  data:GenericEdit = null;
  row:Object = [];
  codeproduct = 513;
  codecompany = 201;
  codecontract = 2;
  codeproductvar=513;
  sub1:Subscription;
  sub:Subscription;
  codetiktok = 1;
  codcategoria = 3381;
  variacao = false;
  table = 'Mktptiktokatributo';
 
  constructor(private http:HTTPService, private uid:UserAuthenticationServices,  private spinner:NgxSpinnerService,
    private snackBar:SnackbarService, private cd:ChangeDetectorRef) { }

    readonly separatorKeysCodes: number[] = [ENTER, COMMA];

    removeOption(item){
      let index = (item.dataValue as Object[]).indexOf(item);
      if (index >= 0){
        (item.dataValue as Object[]).splice(index,1);
      }
      
    }

    addOption(event: MatChipInputEvent, item): void {
      const value = (event.value || '').trim();

      if (value) {
        if ( !item.dataValue ){
          item.dataValue = [];
        }

        (item.dataValue as Object[]).push(value);
      }

      // Clear the input value
      //this.currentFruit.set('');
    }

    selectedChip(event: any, item): void {

        const value = (event.option.value || '').trim();
         if ( !item.dataValue ){
          item.dataValue = [];
        }

        if ( item.dataValue instanceof Array){
          (item.dataValue as Object[]).push(value);
        }else{
          
        }

    }

    displayOption(item: any): string {
      return item ? item.name : '';
    }


    ngOnInit(): void {

      if ( this.data != null){  
        this.row = this.data.row;

        this.codecompany = this.data['parentRow']['linha']['CODECOMPANY'];
        this.codeproduct = this.data['parentRow']['linha']['CODEPRODUCT'];
        this.codeproductvar = this.data['parentRow']['linha']['CODEPRODUCTVAR'];
        this.codecontract = this.data['parentRow']['linha']['CODECONTRACT'];
        this.codetiktok = this.data['parentRow']['linha']['CODETIKTOK'];
        
        if ( this.variacao){
          this.table = 'Mktptitokvar'
        }
        
      }

      this.buttonList.push({
        color:"primary",
        description:"Salvar",
        action: ()=>{
            this.okFunction();
        }
      },
      {
        color:"warn",
        description:"Cancelar",
        action: ()=>{
            this.cancelFunction();
        }
      })


      this.initialize();
    
  }

  initialize(){
    
    this.spinner.show();

    this.getAttributeData().then((result:Object[])=>{
          
           let ob = {
              "expressao": "getRequestData(GetAttribute,Product,{@PARAMETER},GET,null,{@HEADER},{@CODEMKTP})",
              "novo": true,
              "codecompany": this.codecompany,
              "codemktp": 148,
              "codecontract": 0,
              "values":[] 
            }

            let header = {
              key:'@HEADER',
              value:`x-tts-access-token: {@MKTPACTIVECOMPANIES.ACESSTOKEN};content-type: application/json`
            }

            let parameters = {
              key:'@PARAMETER',
              value: '?shop_cipher={@MKTPACTIVECOMPANIES.SIGNATUREMETHOD}&signTikTok({@CODECOMPANY},{@MKTPSERVICES.URL}?shop_cipher={@MKTPACTIVECOMPANIES.SIGNATUREMETHOD},null)'
            }
            
            let CATEGORY_ID = {
              key:'@category_id',
              value: this.codcategoria
            }

            let keepParam = {
              key:'keepParam',
              value: true
            }

            ob['values'].push(header);
            ob['values'].push(parameters);
            ob['values'].push(CATEGORY_ID);
            ob['values'].push(keepParam);

            this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(
              {
              
                next:(con)=>{
                  if( ObjectUtil.isNotEmpty(con['resultado'])){
                    this.transformData(con['resultado']);	
                  }
                  
                  if (result.length > 0 ){
                    for ( var attributos of result ){
                        
                      let dataObject = this.attribs.find(x=>x['id'] == attributos['ID_ATRIBUTO']);
                        
                      if ( attributos['VALUE'] != null ){
                        if ( dataObject != null && dataObject['values']==null ){
                          dataObject['dataValue'] = (JSON.parse(attributos['VALUE']) as object[])[0]['name'];
                        }else{
                          if ( !dataObject['is_multiple_selection']){
                            dataObject['dataValue'] = (JSON.parse(attributos['VALUE']) as object[])[0] ;
                          }else{
                            dataObject['dataValue'] = JSON.parse(attributos['VALUE']) as object[];
                            
                            if ( dataObject['values']!= null && dataObject['dataValue']!=null){
                              const faltando = dataObject['dataValue'].filter(o =>
                                !dataObject['values'].some(d => d.id === o.id)
                              );
                              dataObject['values'].push(...faltando);
                            }
                          }
                        }
                      }
                    }
                  }
                },
                error:(error)=>{
                  this.spinner.hide();
                  throw error;
                },
                complete:()=>{
                  this.spinner.hide();
                  this.cd.detectChanges();
                }
          });
      }).catch((error)=>{
        this.spinner.hide();
        throw error;
      })
      
  }

  isRequired(item){
    if ( item.is_requried ==true){
      return true;
    }else{
      return false;
    }
    
  }

  isVariant(item){
    if ( item.type =='SALES_PROPERTY' ){
      return true;
    }else{
      return false;
    }
    
  }

  deleteItem(item){
      let index = this.attribs.findIndex(i=>i['id'] == item.id);
      this.attribs.splice(index,1);
  } 

  openDataOption(item){
    throw ("Não implementado");
  }

  
  okFunction(){
    this.salvar(); 
  }

  cancelFunction(){
    this.saving.emit({changing:false,keepOpen:false});
  }

  transformData(data){    

    let dataObject = JSON.parse(data)
    this.attribs = dataObject['data']['attributes'];  
  }
  
  prepareData():Object[]{
      let dataObject:Object[] = [];
       
      for ( var data of this.attribs ){
          if ( data['dataValue'] != null && data['dataValue'] != undefined && data['dataValue'] != '' ){
            let ob = {};
            
            if ( data['dataValue']!= null ){
              let dataValue = this.setDataValue(data['dataValue']);
              ob['VALUE'] = JSON.stringify(dataValue);
            }
            
            if ( this.variacao){
               ob['CODEPRODUCTVAR'] = this.codeproductvar;
            }

            if ( data['values']!= null ){
              ob['OPTIONS'] = JSON.stringify(data['values']);
            }
            
            ob['IS_MULTIPLE_SELECTION'] = data['is_multiple_selection'];
            ob['IS_CUSTOMIZABLE'] = data['is_customizable'];
            ob['IS_REQUERIED'] = data['is_requried'];
            ob['TYPE_ATRIBUTO'] = data['type'];
            ob['ID_ATRIBUTO'] = data['id'];
            ob['NAME_ATRIBUTO'] = data['name'];
            ob['CODECOMPANY'] = this.codecompany;
            ob['CODECONTRACT'] = this.codecontract;
            ob['CODEPRODUCT'] = this.codeproduct;
            
            ob['CODETIKTOK'] = this.codetiktok;
            
            dataObject.push(ob);
          }
      }

      return dataObject;
  }

  renderSelected = (value: any) => value?.name || 'Valor inválido';


  setDataValue(object: object):Object[] {
    
    let dataValues:Object[] = [];

    if ( typeof(object)=='string'){
        let val = {
            name: object
        }
        dataValues.push(val);
    }else{
        if ( object instanceof Array){
            for ( var line of object ){
              if ( typeof(line)=='string'){
                let val = {
                    name: line,
                    id:line 
                }
                dataValues.push(val);
              }else{
                dataValues.push(line);
              }
            }
        }else{
          dataValues.push(object);
        }
    }

    return dataValues;
    
  }

  compareValue = (o1: any, o2: any): boolean =>{
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }
    
  salvar(){
    this.spinner.show();
    
    let condicao = `codecompany=${this.codecompany} and codeproduct=${this.codeproduct}`;
    if ( this.variacao ){
      condicao = `codecompany=${this.codecompany} and codeproduct=${this.codeproduct} and codeproductvar = ${this.codeproductvar}`;
    }

    let local = {
      entityName: this.table,
      remove:true,
      removeCondition: condicao,
      data: this.prepareData()
    }
    
    this.http.post(local,'JsonBrokerServices/save',false,true,true).subscribe(result=>{
        this.snackBar.showSuccess("Atributos importados com sucesso.");
        this.saving.emit({changing:true,keepOpen:false});
        this.spinner.hide(); 
    },(error)=>{
        this.spinner.hide();
        throw error;
    });
  }


  async getAttributeData(){

    return await new Promise((resolve,reject)=>{
      
      let ob = {
        "entityName":this.table,
        "sql":`SELECT B.CATEGORY_ID, A.*
              FROM MKTPTIKTOK B LEFT OUTER JOIN MKTPTIKTOKATRIBUTO A  ON A.CODECOMPANY=B.CODECOMPANY
                                                        AND A.CODEPRODUCT=B.CODEPRODUCT
                                                        AND A.CODECONTRACT=B.CODECONTRACT
                                                        AND A.CODETIKTOK=B.CODETIKTOK
                                                        
                                                        
              WHERE B.CODECOMPANY=${this.codecompany}
              AND B.CODEPRODUCT=${this.codeproduct}`
      }

      if ( this.variacao ){
        ob['sql'] = `SELECT B.CATEGORY_ID, A.*
              FROM MKTPTIKTOK B LEFT OUTER JOIN MKTPTIKTOKATRIBUTOVAR A  ON A.CODECOMPANY=B.CODECOMPANY
                                                        AND A.CODEPRODUCT=B.CODEPRODUCT
                                                        AND A.CODECONTRACT=B.CODECONTRACT
                                                        AND A.CODETIKTOK=B.CODETIKTOK
                                                        AND A.CODEPRODUCTVAR=${this.codeproductvar}     
                                                        
              WHERE B.CODECOMPANY=${this.codecompany}
              AND B.CODEPRODUCT=${this.codeproduct}`
              
              
      }
       
      this.sub1 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
        if ( con['SQL'] ){
          this.codcategoria = con['SQL'][0]['CATEGORY_ID'];

          if ( !ObjectUtil.isNotEmpty(this.codcategoria) ){
            throw Error('Não informado o código da categoria no produto.');
          }
          resolve(con['SQL'] as Object[]);
        }
        
      },(error)=>{
          this.spinner.hide();
          throw error;
          
      });
    })
  }
}
